import React, { useEffect } from 'react';
import translations from '../locale/fi.json';
import './ServicePricing.css';
import { FaHands, FaHome, FaStar, FaArrowRight } from 'react-icons/fa';
import { usePageMeta } from '../seo/usePageMeta';

function ServicePricing() {
    usePageMeta({
        title: 'Palvelut ja hinnasto | Jalkojesi Tähden',
        description: 'Kaikki jalkojenhoidon palvelut ja hinnat yhdellä sivulla. Kotikäynnit Kuusamon alueella.',
        canonicalPath: '/palvelut-ja-hinnasto',
        breadcrumbs: [
            { name: 'Etusivu', url: 'https://jalkojesitahden.fi/' },
            { name: 'Palvelut ja hinnasto', url: 'https://jalkojesitahden.fi/palvelut-ja-hinnasto' }
        ]
    });

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                }
            });
        }, { threshold: 0.1 });

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="servicepricing-container">
            <header className="page-hero reveal">
                <div className="page-hero-content">
                    <h1>{translations.service.title} & {translations.pricing.title}</h1>
                    <p>{translations.service.description}</p>
                </div>
                <div className="page-hero-visual">
                    <div className="page-blob page-blob-1"></div>
                    <div className="page-blob page-blob-2"></div>
                </div>
            </header>

            <div className="sp-section">
                <div className="servicepricing-grid">
                    <section className="card reveal">
                        <div className="card-header">
                            <h3><FaHands className="icon" /> {translations.service.basics}</h3>
                        </div>
                        <div className="card-content">
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_basic1}</h4>
                                    <p className="desc">{translations.service.description_basic1}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_basic1}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_basic2}</h4>
                                    <p className="desc">{translations.service.description_basic2}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_basic2}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_basic3}</h4>
                                    <p className="desc">{translations.service.description_basic3}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_basic3}</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="card reveal">
                        <div className="card-header">
                            <h3><FaHome className="icon" /> {translations.service.homevisits}</h3>
                        </div>
                        <div className="card-content">
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_home1}</h4>
                                    <p className="desc">{translations.service.description_home1}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_home1}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_home2}</h4>
                                    <p className="desc">{translations.service.description_home2}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_home2}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_home3}</h4>
                                    <p className="desc">{translations.service.description_home3}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_home3}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_home4}</h4>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_home4}</span>
                                </div>
                            </div>
                            <p className="note">{translations.pricing.home_note}</p>
                        </div>
                    </section>

                    <section className="card reveal">
                        <div className="card-header">
                            <h3><FaStar className="icon" /> {translations.service.special}</h3>
                        </div>
                        <div className="card-content">
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_special1}</h4>
                                    <p className="desc">{translations.service.description_special1}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_special1}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col service">
                                    <h4 className="name">{translations.service.service_special2}</h4>
                                    <p className="desc">{translations.service.description_special2}</p>
                                </div>
                                <div className="col price">
                                    <span className="price-value">{translations.pricing.price_special2}</span>
                                </div>
                            </div>
                            <p className="note">{translations.pricing.special_note}</p>
                        </div>
                    </section>
                </div>

                <div className="contact-section reveal">
                    <p className="special-note">{translations.pricing.special_note2}</p>
                    <a href="/yhteystiedot" className="btn-brand">
                        {translations.pricing.contact_us_button} <FaArrowRight />
                    </a>
                </div>

                <div className="pricing-info reveal">
                    <p>{translations.pricing.cancellation}</p>
                    <p>{translations.pricing.payment}</p>
                </div>
            </div>
        </div>
    );
}

export default ServicePricing;
